// extracted by mini-css-extract-plugin
module.exports = {"Register":"register-user_Register__1nRUR","RegisterForm":"register-user_RegisterForm__1vOPG","submit":"register-user_submit__1wTgb","Completed":"register-user_Completed__3hde4"};